import { useLanguage } from "@/context/LanguageContext";
import { Chapter, Reveal } from "@/components/atoms";

export const HowIWork = () => {
  const { t } = useLanguage();
  const h = t.howIWork;
  return (
    <section className="border-t border-hairline" data-testid="how-i-work-section">
      <div className="px-5 md:px-10 pt-20 md:pt-28">
        <Reveal>
          <Chapter num={h.chapter} label={h.label} />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-10 font-serif font-light tracking-tight leading-none text-4xl sm:text-5xl md:text-6xl" data-testid="how-i-work-headline">
            {h.headline}
          </h2>
        </Reveal>
      </div>
      <div className="mt-12 md:mt-16 border-t border-hairline">
        {h.statements.map((s, i) => (
          <Reveal key={i} delay={0.05 * i}>
            <div
              className="group grid md:grid-cols-12 gap-4 md:gap-8 items-baseline px-5 md:px-10 py-9 md:py-12 border-b border-hairline transition-colors duration-500 hover:bg-cardboard/50"
              data-testid={`work-statement-${i}`}
            >
              <span className="md:col-span-1 font-mono text-[11px] tracking-[0.25em] text-proof">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="md:col-span-5 font-serif font-light tracking-tight text-2xl sm:text-3xl md:text-[2.1rem] leading-tight">
                {s.title}
              </h3>
              <p className="md:col-span-6 text-base md:text-lg font-light leading-relaxed text-smoke group-hover:text-ink/80 transition-colors duration-500">
                {s.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
